<template>
  <div class="login-container">
    <el-card class="login-card">
      <!-- لوگو یا عنوان -->
      <div class="logo-wrapper">
        <img src="/logo5-green.png" alt="لوگو" class="logo" />
        <h3>بازیابی رمز عبور</h3>
      </div>
      <div class="flex items-center justify-center min-h-screen bg-gray-100">
        <div v-if="step === 1">
          <el-form :model="{ mobile }" label-position="top">
            <el-form-item label="شماره موبایل">
              <el-input
                v-model="mobile"
                @input="(val) => (mobile = val.replace(/\D/g, ''))"
                @keyup.enter="sendCode"
                @keypress="numericKeypress"
                placeholder="شماره تلفن همراه خود را وارد کنید "
              />
            </el-form-item>

            <el-button type="primary" class="w-full" @click="sendCode"
              >ارسال کد اعتبار سنجی</el-button
            >
          </el-form>
        </div>

        <div v-if="step === 2">
          <el-form
            :model="{ code, password, passwordConfirmation }"
            label-position="top"
          >
            <input type="text" name="fake-user" style="display: none" />

            <el-form-item label="کد اعتبار سنجی">
              <el-input
                v-model="code"
                clearable
                placeholder="کد اعتبار سنجی "
                :key="inputKey"
                @keypress="numericKeypress"
                @input="(val) => (code = val.replace(/\D/g, ''))"
                autocomplete="new-key"
              />
              <div @click="sendCode" class="timer-class">
                {{
                  timeLeft != 0
                    ? `ارسال مجدد کد تا  (${timeLeft}) ثانیه`
                    : "ارسال مجدد کد اعتبار سنجی"
                }}
              </div>
            </el-form-item>

            <el-form-item label="رمز جدید">
              <el-input
                v-model="password"
                show-password
                placeholder="رمز عبور جدید"
                :key="inputKey"
                @keypress="passwordKeypress"
                autocomplete="new-password"
              />
            </el-form-item>

            <el-form-item label="تکرار رمز جدید">
              <el-input
                v-model="passwordConfirmation"
                show-password
                @keypress="passwordKeypress"
                placeholder="تکرار رمز عبور جدید"
                @keyup.enter="resetPassword"
              />
            </el-form-item>

            <div class="button-group">
              <el-button @click="step = 1">اصلاح شماره موبایل</el-button>
              <el-button
                type="primary"
                @click="resetPassword"
                :loading="isSubmitting"
                >تغییر رمز</el-button
              >
            </div>
          </el-form>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { showToast } from "@/utils/toastHelper";
import {
  passwordKeypress,
  validatePassword,
  numericKeypress,
} from "@/utils/validateInput";

import { validateUser, resetPassword as resetPassApi } from "@/services/auth";

const step = ref(1);
const mobile = ref("");
const code = ref("");
const password = ref("");
const passwordConfirmation = ref("");
const serverID = ref(null);
const inputKey = ref(Date.now());
const timeLeft = ref(90);
let timerInterval = null;
const isSubmitting = ref(false);
const sendCode = async () => {
  if (mobile.value.length !== 11) {
    showToast("شماره موبایل باید 11 رقم باشد", "error");
    return;
  }
  if (step.value == 2 && timeLeft.value != 0) return;
  try {
    serverID.value = await validateUser({ mobile: mobile.value });
    startTimer();
    step.value = 2;
  } catch (error) {
    if (error.response?.data?.mobile) {
      showToast(error.response.data.mobile, "error");
    } else {
      showToast("خطای نامشخصی رخ داده است.", "error");
    }
  }
};

function startTimer() {
  if (timerInterval) clearInterval(timerInterval);
  // اینجا می‌تونی API ارسال کد رو صدا بزنی

  timeLeft.value = 90;

  timerInterval = setInterval(() => {
    timeLeft.value--;
    if (timeLeft.value <= 0) {
      clearInterval(timerInterval);
    }
  }, 1000);
}
const resetPassword = async () => {
  let message = "";
  let valid = true;

  if (!code.value) {
    message += "کد تایید را وارد کنید<br>";
    valid = false;
  }

  if (!validatePassword(password.value)) valid = false;

  if (password.value !== passwordConfirmation.value) {
    message += "تکرار رمز با رمز مطابقت ندارد<br>";
    valid = false;
  }

  if (!valid) {
    if (message != "") showToast(message.trim(), "error");
    return;
  }
  isSubmitting.value = true;
  try {
    await resetPassApi({
      mobile: mobile.value,
      code: code.value,
      password: password.value,
      server_id: serverID.value,
      password_confirmation: passwordConfirmation.value,
    });
    showToast("رمز با موفقیت تغییر کرد", "success");
    showToast("تا چند ثانیه دیگر به سایت منتقل می شوید.", "success");
    setTimeout(() => {
      window.location.href = "/login";
    }, 5000);
  } catch (error) {
    isSubmitting.value = false;
    if (error.response?.data?.message) {
      showToast(error.response.data.message, "error");
    } else {
      showToast("خطا در تغییر رمز", "error");
    }
  }
};
</script>
<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.login-card {
  width: 450px;
  padding: 2rem;
  background: #f9fbfd;
  border-radius: 20px;
}

.logo-wrapper {
  text-align: center;
  margin-bottom: 1.5rem;
}

.logo {
  width: 200px;
  height: 100px;
  margin-bottom: 0.5rem;
}
.button-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px; /* فاصله بین دکمه‌ها */
  margin-top: 10px;
  margin-left: 10px;
}

.button-group .el-button {
  flex: 1 1 110px; /* حداقل عرض 150 پیکسل، بقیه ریسپانسیو */
  max-width: 200px;
}
.timer-class {
  color: darkred;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
</style>
